/**
 * Global error handler for unhandled promise rejections
 * Prevents network errors from showing in React error overlay
 */

export const setupGlobalErrorHandler = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    
    // Suppress network errors from showing in React error overlay
    if (error?.isNetworkError || 
        error?.suppressErrorOverlay ||
        (error?.message === 'Network Error' && !error?.response) ||
        error?.code === 'ERR_NETWORK' ||
        error?.code === 'ECONNREFUSED' ||
        error?.message?.includes('Failed to fetch')) {
      console.warn('Network error suppressed:', error.message || 'Network connection issue');
      event.preventDefault(); // Prevent default error handling
      return;
    }
    
    // Suppress Axios network errors specifically
    if (error?.isAxiosError && !error?.response) {
      console.warn('Axios network error suppressed:', error.message);
      event.preventDefault();
      return;
    }
    
    // For other errors, allow default handling but log them
    // Only log if it's not a known suppressed error type
    if (!error?.suppressErrorOverlay) {
      console.error('Unhandled promise rejection:', error);
    }
  });
  
  // Handle general errors
  window.addEventListener('error', (event) => {
    // Suppress network-related errors
    if (event.message?.includes('Network Error') || 
        event.message?.includes('Failed to fetch') ||
        event.message?.includes('ERR_NETWORK') ||
        event.message?.includes('ECONNREFUSED')) {
      console.warn('Network error suppressed:', event.message);
      event.preventDefault();
      return;
    }
  }, true); // Use capture phase to catch errors early
};

// Call this function in your index.js or App.js



